import React from 'react';
import { observer } from 'mobx-react';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import MembershipEdit from 'pages/builder/memberships/membership_edit';

@observer
class SiteMembershipEdit extends React.Component {

  render() {
    return (
      <MembershipEdit
        {...this.props}
        whiteLabeled
      />
    );
  }
}

export default ErrorBoundary(SiteMembershipEdit);
